import { morphism } from 'morphism'

import countrySchema from './country'
import geoCoordinatesSchema from './geoCoordinates'

import CountryModel from '../models/Country'
import GeoCoordinates from '../models/GeoCoordinates'

export default {
  id: 'id',
  name: 'name',
  city: 'city',
  country: ({ country = {} }) => {
    return morphism(countrySchema, country, CountryModel)
  },
  geoCoordinates: ({ geoCoordinates = {} }) => {
    return morphism(geoCoordinatesSchema, geoCoordinates, GeoCoordinates)
  },
}
